import { keymap } from "prosemirror-keymap";
import { Extension } from "../../core/extension";
import { toggleMark } from "../../commands/commands";
import { strikethroughMarkSpec } from "./schema";
import { createKeybindingByPlatform } from "../../helpers/createKeybindingByPlatform";
export class StrikethroughExtension extends Extension {
    addMarks(marks) {
        return marks.append(strikethroughMarkSpec());
    }
    addCommands(schema) {
        return {
            toggleStrikethrough: toggleMark(schema.marks.strikethrough),
        };
    }
    addPlugins(schema, plugins, { commands }) {
        return plugins.concat([
            keymap({
                "Mod-shift-x": createKeybindingByPlatform("macos", commands.toggleStrikethrough),
                "Alt-shift-5": createKeybindingByPlatform("other", commands.toggleStrikethrough),
            }),
        ]);
    }
}
